import React from "react";
import { useTranslation } from "react-i18next";
import AccountDeletionPublicLayout from "./PublicLayout";
import { useSensitivePublicPage } from "../../../hooks/useSensitivePublicPage";

const AccountDeletionStatusPage = () => {
    const { t } = useTranslation();
    useSensitivePublicPage(t("accountDeletionPublic.status.documentTitle"));

    return (
        <AccountDeletionPublicLayout
            title={t("accountDeletionPublic.status.genericTitle")}
            description={t("accountDeletionPublic.status.genericDescription")}
            showRecoveryLink
            showRestrictedLink
        >
            <div className="account-deletion-public-card__status" role="status" aria-live="polite">
                <p>{t("accountDeletionPublic.status.genericNotice")}</p>
            </div>
        </AccountDeletionPublicLayout>
    );
};

export default AccountDeletionStatusPage;
